<template>
  <v-container fluid>
    <v-row class="justify-space-around">
      <v-col cols="12" md="6" class="justify-end align-end text-end">
        <v-btn color="success" @click="showModal">
          <v-icon class="white--text">mdi-plus</v-icon>
          Create SMS Campaign
        </v-btn>
      </v-col>
      <v-col cols="12" md="6" class="justify-end align-end text-end">
        <v-btn color="success" @click="showSelector">
          <v-icon class="white--text">mdi-plus</v-icon>
          Create Filtered SMS Campaign
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog v-model="dialog" width="600">
        <sms-campaign-form @campaignSuccess="success"/>
      </v-dialog>
    </v-row>
    <v-row>
      <v-dialog v-model="dialog2" width="600">
        <filtered-sms-form @campaignSuccess="success"/>
      </v-dialog>
    </v-row>
    <v-row>
      <v-col cols="12">
        <table-widget title="SMS Campaigns" :freeze-item="true" :headers="headers" :table-row-data="sms"
                      @deleteItem="deleteItem" @freezeUnfreeze="confirmMessageAndSend"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TableWidget from "@/components/widgets/tables/TableWidget";
import SmsCampaignForm from "@/components/widgets/forms/smsCampaignForm";
import {deleteRequest, getRequest, postRequest} from "@/api/apirepository";
import FilteredSmsForm from "@/components/widgets/forms/filteredSmsForm";

export default {
  name: "SmsCenter",
  metaInfo: {
    title: 'Sms Center',
  },
  components: {FilteredSmsForm, SmsCampaignForm, TableWidget},
  data() {
    return {
      headers: [

        {text: 'Level', value: 'level'},
        {text: 'County', value: 'county'},
        {text: 'Constituency', value: 'constituency'},
        {text: 'Ward', value: 'ward'},
        {text: 'Polling Station', value: 'pollingstation'},
        {text: 'Message', value: 'message'},
        {text: 'Sender ID', value: 'sender_id.SenderId'},
        {text: 'Status', value: 'status'},
        {text: 'Total Cost', value: 'totalCost'},
        {text: 'Actions', value: 'action'}
      ],
      sms: [],
      dialog: false,
      dialog2: false,
    }
  },
  methods: {
    showModal() {
      this.dialog = true;
    },
    showSelector() {
      this.dialog2 = true;
    },
    deleteItem(e) {
      swal.fire({
        title: 'Delete Campaign?',
        text: "This step is irrevesible",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Delete!'
      }).then((result) => {
        if (result.value) {
          deleteRequest('smsCampaign', e.item.id).then(e => {
            this.getSMSCampaigns()
            swal.fire('Deleted Successfully', '', "success")
          }).catch(e => {
            console.log(e)
          })
        }
      })

    },
    confirmMessageAndSend(e) {
      swal.fire({
        title: 'Send SMS?',
        text: "Ensure you have enough funds in your account",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Release SMS!'
      }).then((result) => {
            if (result.value) {
              postRequest('releaseSMS', {
                smsId: e.item.id,
                id: this.$store.state.user.id,
              }).then(e => {
                    this.getSMSCampaigns()
                    swal.fire('Sent Successfully', '', "success")
                  }
              ).catch(e => {
                console.log(e)
              })
            }
          }
      )

    },
    success() {
      this.dialog = false;
      this.getSMSCampaigns()
      swal.fire('Success', 'Created Campaign successfully', 'success')
    }
    ,
    getSMSCampaigns() {
      getRequest('smsCampaign', {
        params: {
          userId: this.$store.state.user.id
        }
      }).then(({data}) => {
        this.sms = data;
      }).catch(e => {
        console.log(e)
      })
    }
  },
  created() {
    this.getSMSCampaigns()
  }
}
</script>

<style scoped>

</style>